import { LoadingOutlined } from '@ant-design/icons';
import BottomSheet from 'components/UI/Responsive/BottomSheet';
import DetailList from 'components/UI/Responsive/DetailList';
import { OrderIntention } from 'model/OrderIntention';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { buyIntenteionSelectors } from 'store/state/selectors';
import { OrderIntentionAction } from '../List/useOrderIntentionActions';
import { buildOrderIntentionDetailGroups } from './buildOrderIntentionDetailGroups';

import * as S from './styles';

export type DetailAction = OrderIntentionAction & {
  tone?: 'primary' | 'danger';
};

interface Props {
  order: OrderIntention | null;
  actions: DetailAction[];
  onClose: () => void;
}

function SheetContent({
  order,
  actions,
  onClose,
}: { order: OrderIntention } & Props) {
  const customer = useSelector(buyIntenteionSelectors.getCustomer);
  const [runningKey, setRunningKey] = useState<string>();

  const runAction = async (action: DetailAction) => {
    const result = action.onSelect();
    if (result instanceof Promise) {
      setRunningKey(action.key);
      await result;
    }
    onClose();
  };

  const footer = actions.length > 0 && (
    <S.Actions aria-label="Ações do pedido" data-count={actions.length}>
      {actions.map((action) => (
        <S.ActionButton
          key={action.key}
          type="button"
          data-tone={action.tone}
          aria-busy={runningKey === action.key}
          disabled={Boolean(runningKey)}
          onClick={() => runAction(action)}
        >
          {runningKey === action.key && <LoadingOutlined aria-hidden />}
          {action.label}
        </S.ActionButton>
      ))}
    </S.Actions>
  );

  return (
    <BottomSheet
      isOpen
      onClose={onClose}
      title={`${order.productCode} – ${order.productDescription}`}
      footer={footer || undefined}
    >
      <S.SheetDetail>
        <DetailList
          groups={buildOrderIntentionDetailGroups(order, customer?.branch)}
        />
      </S.SheetDetail>
    </BottomSheet>
  );
}

export function OrderIntentionDetailSheet({ order, actions, onClose }: Props) {
  if (!order) return null;
  return <SheetContent order={order} actions={actions} onClose={onClose} />;
}
